import { PushNotifications } from "@capacitor/push-notifications";
import { NativeBiometric } from "@capgo/capacitor-native-biometric";
import reportErrorSentry from "src/lib/reportErrorSentry";
import type { PermissionState } from "../types";

/**
 * Collects permission statuses for device tracking
 * Returns safe defaults if permission checks fail
 */
export async function collectPermissions(): Promise<{
  pushNotificationStatus: PermissionState;
  biometricAvailable: boolean;
}> {
  const [pushStatus, bioAvailable] = await Promise.all([
    getPushNotificationStatus(),
    getBiometricAvailability()
  ]);

  return {
    pushNotificationStatus: pushStatus,
    biometricAvailable: bioAvailable
  };
}

/**
 * Get push notification permission status
 * Returns 'prompt' if check fails
 */
async function getPushNotificationStatus(): Promise<PermissionState> {
  try {
    const permission = await PushNotifications.checkPermissions();
    return permission.receive;
  } catch (error) {
    reportErrorSentry(error);
    return "prompt";
  }
}

/**
 * Check if biometric authentication is available
 * Returns false if check fails
 */
async function getBiometricAvailability(): Promise<boolean> {
  try {
    const result = await NativeBiometric.isAvailable();
    return result.isAvailable;
  } catch (error) {
    reportErrorSentry(error);
    return false;
  }
}
